import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { handleError } from "../../components/utils/AuthenticationCheck";

const CreateDenomination = () => {
    const [formData, setFormData] = useState({
        network_id: "",
        amount: "",
        count: "",
        branch_product_unit_id: "",
    });
    const [bpuList, setBpuList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bpuLoading, setBpuLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBPU = async () => {
            setBpuLoading(true);
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;
                if (!token) throw new Error("No access token found.");

                const response = await axios.get(ApiServices.getDenominationBPU, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                });

                const { status, data } = response.data;
                if (status === 200) {
                    setBpuList(data);
                } else {
                    handleError({ response: { status, data: response.data } }, navigate);
                }
            } catch (error) {
                handleError(error, navigate);
            } finally {
                setBpuLoading(false);
            }
        };

        fetchBPU();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const payload = {
                amount: formData.amount,
                count: formData.count,
            };
            if (formData.network_id) payload.network_id = formData.network_id;
            if (formData.branch_product_unit_id) {
                payload.branch_product_unit_id = formData.branch_product_unit_id;
            }

            const response = await axios.post(
                ApiServices.createDenomination,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === 200 || status === 201) {
                toast.success(message, { toastId: "denomination-create-success" });
                navigate("/admin/denomination/list");
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Denomination
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Create</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    <div className="bg-white p-6 rounded-lg shadow-sm">
                        <h2 className="text-lg font-semibold text-darkGreen3 mb-4">
                            Create Denomination
                        </h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Amount <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleChange}
                                    required
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-darkGreen3"
                                    placeholder="e.g. 500"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Count <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    name="count"
                                    value={formData.count}
                                    onChange={handleChange}
                                    required
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-darkGreen3"
                                    placeholder="e.g. 10"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Network (optional)
                                </label>
                                <select
                                    name="network_id"
                                    value={formData.network_id}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-darkGreen3"
                                >
                                    <option value="">-- Select Network --</option>
                                    <option value="1">MTN</option>
                                    <option value="2">Airtel</option>
                                    <option value="3">Glo</option>
                                    <option value="4">9Mobile</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Branch Product Unit (optional)
                                </label>
                                {bpuLoading ? (
                                    <Spinner loading={bpuLoading} />
                                ) : (
                                    <select
                                        name="branch_product_unit_id"
                                        value={formData.branch_product_unit_id}
                                        onChange={handleChange}
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-darkGreen3"
                                    >
                                        <option value="">-- Select BPU --</option>
                                        {bpuList.map((bpu) => (
                                            <option key={bpu.id} value={bpu.id}>
                                                {bpu.name}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>

                            <div className="flex gap-3 pt-2">
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5"
                                >
                                    {loading ? "Creating..." : "Create Denomination"}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/admin/denomination/list")}
                                    className="text-gray-700 bg-gray-200 hover:bg-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </MainLayouts>
        </div>
    );
};

export default CreateDenomination;
